enum ServiceTypeLayoutEnum {
  'banner' = 1,
  'carrossel img' = 2
}

export default ServiceTypeLayoutEnum;
